
import ArrowRight from "../../../assets/duotone/ArrowRight.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowRightIcon({ className, dataTestid = "ArrowRightIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowRight data-testid={dataTestid} className={classes} {...rest} />
  );
}
